export const TAB_TYPES = {
  SKIPPED: "SKIPPED",
  APPLIED: "APPLIED",
};

export const COLUMN_TYPES = {
  STUDENT_NAME: "STUDENT_NAME",
  ERROR: "ERROR",
  GRADE_LEVELS_APPLIED: "GRADE_LEVELS_APPLIED",
};

export const UI_TYPES = {
  TEXT_WITH_AVATAR: "TEXT_WITH_AVATAR",
  ERROR_CELL: "ERROR_CELL",
  GRADE_LEVELS_CELL: "GRADE_LEVELS_CELL",
};

export const getFeedListColumns = t => ({
  [TAB_TYPES.SKIPPED]: [
    {
      id: COLUMN_TYPES.STUDENT_NAME,
      type: "CUSTOM",
      label: t("common:student_name"),
      uiType: UI_TYPES.TEXT_WITH_AVATAR,
      style: { width: "407px", maxWidth: "407px" },
    },
    {
      id: COLUMN_TYPES.ERROR,
      type: "CUSTOM",
      label: t("common:error"),
      uiType: UI_TYPES.ERROR_CELL,
      style: { width: "407px", maxWidth: "407px" },
    },
  ],
  [TAB_TYPES.APPLIED]: [
    {
      id: COLUMN_TYPES.STUDENT_NAME,
      type: "CUSTOM",
      label: t("common:student_name"),
      uiType: UI_TYPES.TEXT_WITH_AVATAR,
      style: { width: "407px", maxWidth: "407px" },
    },
    {
      id: COLUMN_TYPES.GRADE_LEVELS_APPLIED,
      type: "CUSTOM",
      label: t("common:label_updated", {
        label: t("common:grade_levels"),
      }),
      uiType: UI_TYPES.GRADE_LEVELS_CELL,
      style: { width: "407px", maxWidth: "407px" },
    },
  ],
});

export const ERROR_TYPES = {
  TODDLE_DEFINED_GRADE_CONFLICT: "TODDLE_DEFINED_GRADE_CONFLICT",
  TODDLE_DEFINED_GRADE_MISSING: "TODDLE_DEFINED_GRADE_MISSING",
  TODDLE_DEFINED_GRADE_STRUCTURE_MISMATCH:
    "TODDLE_DEFINED_GRADE_STRUCTURE_MISMATCH",
};

export const ERROR_TYPE_TO_MESSAGE_LOCALE = {
  [ERROR_TYPES.TODDLE_DEFINED_GRADE_CONFLICT]:
    "transcript:label_exists_as_toddle_defined_grade_level",
  [ERROR_TYPES.TODDLE_DEFINED_GRADE_MISSING]:
    "transcript:label_does_not_exists_as_toddle_defined_grade_level",
  [ERROR_TYPES.TODDLE_DEFINED_GRADE_STRUCTURE_MISMATCH]:
    "transcript:grade_level_structure_mismatch_error",
};
